import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the IntroProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IntroProvider {

  constructor(public http: HttpClient) {

  }

  getElementPosition(element): Promise<any> {
    let elementPosition: any = [];
    let elementHtml = document.getElementById(element);

    if (!elementHtml) {
      return null;
    }

    let elementTop = elementHtml.offsetTop;
    let elementHeight = elementHtml.offsetHeight;
    let elementButtom = elementTop + elementHeight;
    //  let textPosition = "";
    if (elementButtom <= 300) {
      console.log("pos buble is bottom");
    } else {
      console.log("pos buble is top");
    }
    elementPosition = {
      top: elementTop + "px",
      height: elementHeight + "px",
      buttom: elementButtom + "px"

    }
    return elementPosition;
  }

}



// WEBPACK FOOTER //
// ./src/providers/intro/intro.ts